// const eventBus = {
//     on(event, callback) {
//         documents.addEventListener(event, (e) => callback(e.detail));
//     },
//     dispatch(event, data) {
//         documents.dispatchEvent(new CustomEvent(event, { detail: data }));
//     },
//     remove(event, callback) {
//         documents.removeEventListener(event, callback);
//     },
// };

// export default eventBus;

import { Subject } from "rxjs";

const eventBus = new Subject();

export default eventBus;

export var OrganizationChange = "organization.change";


export var AuthorizationCheckRequired = "authorization.check";


export var Asset_NewAssetTypeDrawer_Open = "asset.new_asset_type_drawer.open";
export var Asset_NewAssetDrawer_Open = "asset.new_asset_drawer.open";


export var AuthenticationLoggedInEvent = "auth.logged_in";






export var Application_Add_Note_Drawer_Open = "application.add_note_drawer.open";
export var Application_Notification_Updated = "application.notification.updated";


export var Application_Accept_Modal_Open = "application.accept_modal.open";
export var Application_Updated = "application.updated";
export var Application_Activity_Updated = "application.activity_updated";

export var Application_PM_Statuses_Updated = "application.pm_statuses.updated";


export var Site_Maps_Updated = "site-maps.updated";

export var AssetContracts_Updated = "asset_contracts.updated";



export var AssetRelationshipsUpdated = "asset_relationships.updated";

export var AssetRelationshipTypesUpdate = "asset.relationship-types.updated";

export var OrganizationAccessUpdated = "organization.access.updated";

export var AssetUpdated = "asset.updated";

export var AssetImagesUpdated = "asset.images.updated";

export var ApplicationContractUpdate = "application.contract.updated";
export var ApplicationTagsUpdated = "application.resource_tags.updated";
export var ApplicationTenantUpdated = "application.application_tenant.updated";
export var AssetReservationsUpdated = "asset.reservations.updated";
export var AssetDetailsUpdated = "asset.details.updated";
export var AssetDuplicated = "asset.duplicated";
export var AssetNameUpdated = "asset.name.updated";
export var AssetTagsUpdated = "asset.resource_tags.updated";
export var AssetTypeUpdated = "asset-type.updated";
export var AssetAttributeUpdated = "asset.attribute.updated";

export var AssetLayoutsUpdated = "asset.layouts.updated";
export var AssetLocationsUpdated = "asset.locations.updated";
export var AssetPricingPlansUpdate = "asset.pricing-plans.updated";

export var InvoiceUpdated = "invoice.updated";
export var LegalEntitiesUpdated = "LegalEntities.updated";
export var LegalEntitiesBankAccountsUpdated = "LegalEntities.bank_accounts.updated";

export var TemplatesUpdated = "templates.updated";
export var FormTemplatesUpdated = "form.templates.updated";
export var TagsUpdated = "tags.updated";

export var ApplicationNotesUpdate = "application.notes.updated";
export var ApplicationFilesUpdate = "application.files.updated";

export var LocationFilesUpdate = "location.files.updated";

export var LocationNotesUpdate = "location.notes.updated";

export var LegalEntityFilesUpdate = "legal_entity.files.updated";

export var OrganizationContactAdded = "organization.contact.added";
export var OrganizationContactUpdated = "organization.contact.updated";
export var TenantFilesUpdate = "tenant.files.updated";

export var LocationAssetTypeSalesTaxUpdated = "location.asset_type_sales_tax.updated";

export var CaseTemplatesUpdated = "case-templates.updated";
export var ApplicationTransfersUpdated = "application.transfers.updated";


export var TenantPaymentSystemAccountsUpdated = "tenant.payment-system-accounts.updated";

export var TenantTransfersUpdated = "tenant.transfers.updated";
export var SalesTaxRateUpdated = "cost.sales_tax_rate.updated";

export var AssetsUpdated = "assets.updated";
export var TenantUpdated = "tenant.updated";



export var LocationAssetsDetails = "location.assets-details.updated";


export var ApplicationTenantPayout = "application.tenant-paymout";

